<template>
  <div id="app">
    <router-view/>
    <img v-if="this.$root.showBg" class="backrgound" src="./assets/roleList/bg_dark@2x.png" />
  </div>
</template>

<script>
import Share from '@/js/shareAndGetName'
import '../node_modules/animate.css/animate.css'

export default {
  data () {
    return {
    }
  },
  methods: {
    test (desc) {
      const share = new Share({ pic: 'http://wx1.sinaimg.cn/large/006Zdy2vgy1g0fd9no3cyj305f05fmwz.jpg', url: window.location.href.split('#')[0], title: '嘘~悄悄把心告诉你', desc: desc })
      share.appShare()
      share.rawWeiXinShare(this.url)
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
  .backrgound {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 110%;
    z-index: -1;
  }
</style>
<style lang="scss">
  .test {
    position: fixed;
    bottom: 0px;
    left:0px;
  }
  .done-template {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 2;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
    .done {
      position: relative;
      .close {
        width: 20px;
        position: absolute;
        right: 0px;
        top: 0px;
        opacity: 0.6;
      }
      .done-img {
        width: 270px;
      }
      width: 250px;
    }
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    overflow: hidden;
    width: 100vw;
    // min-width: 375px;
    height: max-content;
    min-height: 100vh;
    font-size: px2html(12px);
    .app-template {
      // -webkit-overflow-scrolling: touch;
      // overflow-y: scroll;
      // width: 100vw;
      // height: 100vh;
      z-index: 1;
    }
  }
</style>

<style lang="scss">
  .remove-unclick {
    pointer-events: unset;
  }
  img {
    pointer-events: none;
  }
  body {
    height: 100vh;
  }
  * {
    padding: 0;
    margin: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0); // ios 去除点击阴影
    -webkit-tap-highlight-color:transparent;
  }
  a,a:link,a:visited,a:hover,a:active{
    text-decoration: none;
    color:inherit;
  }
  input[type=button], input[type=submit], input[type=file], button { cursor: pointer; -webkit-appearance: none; }
</style>
<style lang="scss">
  .roatate-animation {
    animation: rotate 12s linear infinite;
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .rotate-30 {
    transform-origin: left;
    transform: rotate(20deg);
  }
</style>
